import { legacy_createStore as createStore, applyMiddleware, Reducer } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { thunk } from 'redux-thunk';

export function createReduxStore(reducer: Reducer<any, any>) {
  return createStore(reducer, composeWithDevTools(applyMiddleware(thunk)));
}
